import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import lt from './locales/lt.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      lt: {
        translation: lt
      },
      en: {
        translation: en
      }
    },
    lng: 'lt', // Set Lithuanian as default language
    fallbackLng: 'lt', // Fallback to Lithuanian if translation is missing
    detection: {
      // Options for language detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false // React already does escaping
    }
  });

export default i18n;
